import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { PaytrieAPI } from '@paytrie/client'

const REFETCH_INTERVAL_MS = 60 * 1000

export class MaintenanceWindowsError extends Error {
  constructor(readonly status: number) {
    super(`Failed to load maintenance windows (status ${status})`)
  }
}

export const useMaintenanceWindows = ({
  lookbackDays,
}: {
  lookbackDays: number
}) =>
  useQuery({
    queryKey: ['v2', 'maintenance-windows', lookbackDays],
    queryFn: async () => {
      const res = await PaytrieAPI.listMaintenanceWindows({
        endsAfter: dayjs()
          .subtract(lookbackDays - 1, 'day')
          .startOf('day')
          .toISOString(),
      })
      if (res.status !== 200) {
        throw new MaintenanceWindowsError(res.status)
      }
      return res.data.data
    },
    refetchInterval: REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  })
